// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --toastify-color-light: #2a3a42;
  --toastify-text-color-light: #FFF;
}

.__create__container {
  display: block;
  height: fit-content;
}

.create__title {
  color: var(--primary);
  font-weight: 500;
  font-size: var(--title);
  margin: 0.5rem auto;
}

.create__row {
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
  border-radius: 4px;
  padding: 0.5rem 1rem 1rem 1rem;
  display: grid;
  grid-column-gap: 12px;
  grid-template-columns: repeat(2, 1fr);
  background: #ffffff;
  margin-top: 5px;
}

.create__row__wrapper {
  width: fit-content;
}

.create__wrapper {
  display: block;
  justify-content: space-between;
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
  border-radius: 4px;
  margin-top: 5px !important;
  background: #ffffff;
}

.create__wrapper_btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
}

.__checkbox__container__ {
  display: flex;
  height: 40%;
  align-items: center;
}

.__checkbox__control__create {
  padding-right: 3rem;
}

.ms-ChoiceField-input:checked + .ms-ChoiceField-field:before {
  background-color: #666666;
  border-color: #666666;
  color: #666666;
  border-radius: 50%;
  content: '\\00a0';
  display: inline-block;
  position: absolute;
  top: 5px;
  bottom: 0;
  left: 5px;
  width: 9px;
  height: 9px;
  box-sizing: border-box;
}

.ms-ChoiceField-field:after {
  content: '';
  display: inline-block;
  border: 1px #c8c8c8 solid;
  width: 19px;
  height: 19px;
  cursor: pointer;
  position: relative;
  font-weight: normal;
  left: -1px;
  top: -1px;
  border-radius: 50%;
  position: absolute;
}

@media (max-height: 767px) {
  .create__row {
    height: 15%;
  }
}

.is-checked .ms-Checkbox-checkbox {
  color: var(--primary);
  background: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/createTab/CreateTab.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,6CAA6C;EAC7C,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B","sourcesContent":[":root {\n  --toastify-color-light: #2a3a42;\n  --toastify-text-color-light: #FFF;\n}\n\n.__create__container {\n  display: block;\n  height: fit-content;\n}\n\n.create__title {\n  color: var(--primary);\n  font-weight: 500;\n  font-size: var(--title);\n  margin: 0.5rem auto;\n}\n\n.create__row {\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n  border-radius: 4px;\n  padding: 0.5rem 1rem 1rem 1rem;\n  display: grid;\n  grid-column-gap: 12px;\n  grid-template-columns: repeat(2, 1fr);\n  background: #ffffff;\n  margin-top: 5px;\n}\n\n.create__row__wrapper {\n  width: fit-content;\n}\n\n.create__wrapper {\n  display: block;\n  justify-content: space-between;\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n  border-radius: 4px;\n  margin-top: 5px !important;\n  background: #ffffff;\n}\n\n.create__wrapper_btn {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n}\n\n.__checkbox__container__ {\n  display: flex;\n  height: 40%;\n  align-items: center;\n}\n\n.__checkbox__control__create {\n  padding-right: 3rem;\n}\n\n.ms-ChoiceField-input:checked + .ms-ChoiceField-field:before {\n  background-color: #666666;\n  border-color: #666666;\n  color: #666666;\n  border-radius: 50%;\n  content: '\\00a0';\n  display: inline-block;\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  left: 5px;\n  width: 9px;\n  height: 9px;\n  box-sizing: border-box;\n}\n\n.ms-ChoiceField-field:after {\n  content: '';\n  display: inline-block;\n  border: 1px #c8c8c8 solid;\n  width: 19px;\n  height: 19px;\n  cursor: pointer;\n  position: relative;\n  font-weight: normal;\n  left: -1px;\n  top: -1px;\n  border-radius: 50%;\n  position: absolute;\n}\n\n@media (max-height: 767px) {\n  .create__row {\n    height: 15%;\n  }\n}\n\n.is-checked .ms-Checkbox-checkbox {\n  color: var(--primary);\n  background: var(--primary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
